module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-five.7221b74b.png";